import qs from 'qs'

const queryString = {
  parse: qs.parse,
  stringify: (obj: Record<string, unknown>) =>
    qs.stringify(obj, { arrayFormat: 'brackets', encodeValuesOnly: true }),
}

export default queryString
